module.exports = __webpack_public_path__ + "fonts/Catamaran-ExtraLight.d005aac0.woff2";